import React from 'react';
import PropTypes from 'prop-types';
import { Stack } from '@mui/material';
import { FileGroupItem } from './FileGroupItem';
import { GROUPBY_TYPES } from '../filePlayerConstants';

export const FileGroupLayout = ({ groups, groupBy }) => (
  <Stack spacing={2} mt={2}>
    {groups.map((group) => (
      <FileGroupItem
        key={`group-${groupBy}-${group.id}`}
        group={group}
        groupBy={groupBy}
      />
    ))}
  </Stack>
);

FileGroupLayout.propTypes = {
  groups: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      label: PropTypes.string,
      fileCount: PropTypes.number.isRequired,
    }),
  ).isRequired,
  groupBy: PropTypes.oneOf(GROUPBY_TYPES).isRequired,
};
